import React, { useEffect } from 'react'
import { getParameterByName, UClick } from '../../components/common/utils'
import style from './GlobalEcards.module.css'

const GlobalEcards = () => {
  useEffect(() => {
    const utmSource = getParameterByName('utm_source')
    UClick(utmSource === 'padi_app' ? 'fromPadiApp' : 'fromGlobalEcards')
  }, [])

  return (
    <div className={style.bg}>
      <img src={require('../../assets/images/common/global_page.jpg')} alt="qr" className={style.content} />
    </div>
  )
}

export default GlobalEcards
